// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_ZbS","cls2":"YourPaperCard-cls2_7du YourPaperCard-cls1_ZbS"};